import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getDataRequest } from "../../helper/AxiosHelper";
import {
  Box,
  Grid,
  Container,
  Stack,
  Button,
  Paper,
} from "@mui/material";
import CommonTable from "../../components/common/CommonTable";
import CommonFilter from "../../components/common/CommonFilter";
import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import AddIcon from "@mui/icons-material/Add";
import TableConfig from "../../components/organization/organizationGrps/orgGrpListTableContent.jsx";

export default function Component() {
  const { org_id: orgId } = useParams();
  const [filterQuery, setFilterQuery] = useState([]);
  const [orgData, setOrgData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    getDataRequest(`organization/show/${orgId}`, (isSuccess, data) => {
      if (!isSuccess) {
        return;
      }
      setOrgData(data.record || {});
    });
  }, [orgId]);

  return (
    <Container maxWidth={"lg"}>
      <CommonBreadcrumb dbData={orgData} />

      <Paper sx={{ px: 3, pb: 3, mt: 6 }} elevation={3}>
        <Grid container rowSpacing={3} columnSpacing={2}>
          <Grid item xs={12}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box>
                <CommonFilter
                  filterConfig={TableConfig.filterConfig}
                  emitQueryFn={setFilterQuery}
                />
              </Box>
              <Box>
                <Button
                  size="small"
                  variant="contained"
                  endIcon={<AddIcon />}
                  onClick={() => navigate(`/organization/${orgId}/grp/create`)}
                >
                  新增社
                </Button>
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <CommonTable
              filterQuery={filterQuery}
              tableConfig={TableConfig}
              urlParma={{ org_id: orgId }}
            />
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
